
import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { 
  Sidebar, 
  SidebarContent, 
  SidebarFooter, 
  SidebarHeader, 
  SidebarMenu,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarTrigger,
  useSidebar
} from "@/components/ui/sidebar";
import MenuItems from "./MenuItems";
import UserSection from "./UserSection";

const AppSidebar = () => {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const { isCollapsed } = useSidebar();

  return (
    <Sidebar>
      {!isMobile && (
        <SidebarHeader>
          <div className="flex justify-center">
            <img 
              src="https://www.luijtenvvz.nl/wp-content/uploads/2025/02/LVVZ-Jubileum-RGB-webshop.svg" 
              alt="Luijten VVZ Logo" 
              className={isCollapsed ? "h-8" : "h-[39px]"} 
            />
          </div>
          <SidebarTrigger className="absolute right-2 top-4" />
        </SidebarHeader>
      )}
      <SidebarContent>
        {isMobile ? (
          <>
            {user && <MenuItems role={user.role} />}
          </>
        ) : (
          <SidebarGroup>
            <SidebarGroupLabel>Hoofdmenu</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {user && <MenuItems role={user.role} />}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        )}
      </SidebarContent>
      <SidebarFooter className={isMobile ? "border-t p-2" : "border-t p-4"}>
        <UserSection />
      </SidebarFooter>
    </Sidebar>
  );
};

export default AppSidebar;
